/* Stuttgart Modehaus – Brand JS: Farbkacheln, Labels, Warenkorb-Fortschritt, Größenassistent */
(function () {
  'use strict';
  var SMH = window.SMH = window.SMH || {};
  var NBSP = String.fromCharCode(160);

  /* ---------------------------------------------------------
     1. Optionsnamen eindeutschen
     --------------------------------------------------------- */
  var LABEL_MAP = {
    color: 'Farbe', colour: 'Farbe', colors: 'Farbe', farben: 'Farbe',
    size: 'Größe', sizes: 'Größe',
    material: 'Material', style: 'Ausführung', length: 'Länge',
    type: 'Ausführung', model: 'Modell', set: 'Set'
  };

  function translateLabels(scope) {
    Array.prototype.forEach.call(scope.querySelectorAll('.variant__label'), function (lab) {
      for (var i = 0; i < lab.childNodes.length; i++) {
        var n = lab.childNodes[i];
        if (n.nodeType === 3 && n.textContent.trim()) {
          var key = n.textContent.trim().toLowerCase();
          if (LABEL_MAP[key]) n.textContent = LABEL_MAP[key] + ' ';
          break;
        }
      }
    });
    Array.prototype.forEach.call(scope.querySelectorAll('.variant-input-wrap'), function (w) {
      var nm = (w.getAttribute('name') || '').toLowerCase();
      if (LABEL_MAP[nm]) w.setAttribute('data-smh-label', LABEL_MAP[nm]);
    });
  }

  /* ---------------------------------------------------------
     2. Farb-Swatches als rechteckige Bildkacheln
     --------------------------------------------------------- */
  var COLOR_WORDS = ['farbe', 'color', 'colour', 'farben'];

  function variantData(scope) {
    var el = scope.querySelector('[data-variant-json]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function sizedSrc(src) {
    if (!src) return src;
    var q = src.indexOf('?');
    var base = q > -1 ? src.slice(0, q) : src;
    var tail = q > -1 ? src.slice(q) : '';
    var dot = base.lastIndexOf('.');
    if (dot < 0) return src;
    return base.slice(0, dot) + '_200x' + base.slice(dot) + tail;
  }

  var CSS_COLORS = {
    'army green': '#4B5320', 'dark green': '#1E3B26', 'sapphire blue': '#0F52BA',
    'dark blue': '#1B2A4A', 'black': '#1A1B1E', 'brown': '#5C4033', 'red': '#9B1B23',
    'white': '#F5F3EF', 'beige': '#D8C7AE', 'grey': '#8A8A8A', 'gray': '#8A8A8A',
    'navy': '#1B2A4A', 'cream': '#EFE7D9', 'camel': '#B98B54', 'burgundy': '#6E1F2E',
    'pink': '#D9A0AC', 'purple': '#6B4A7A', 'yellow': '#D8B54A', 'orange': '#C2703A',
    'khaki': '#78764B', 'blue': '#2B4C7E', 'green': '#3B5F3B', 'silver': '#C6C6C6', 'gold': '#B79445'
  };

  function fallbackColor(name) {
    var k = String(name).toLowerCase().trim();
    if (CSS_COLORS[k]) return CSS_COLORS[k];
    var parts = k.split(' ');
    for (var i = parts.length - 1; i >= 0; i--) { if (CSS_COLORS[parts[i]]) return CSS_COLORS[parts[i]]; }
    return '#D3CBBF';
  }

  function buildSwatches(scope) {
    var variants = variantData(scope);
    var wraps = scope.querySelectorAll('.variant-input-wrap');
    Array.prototype.forEach.call(wraps, function (wrap) {
      var name = (wrap.getAttribute('name') || '').toLowerCase();
      var handle = (wrap.getAttribute('data-handle') || '').toLowerCase();
      var isColor = COLOR_WORDS.some(function (w) { return name.indexOf(w) > -1 || handle.indexOf(w) > -1; });
      if (!isColor || wrap.classList.contains('smh-swatches')) return;

      var imgFor = {};
      if (variants && variants.length) {
        var idx = parseInt((wrap.getAttribute('data-index') || 'option1').replace('option', ''), 10);
        var key = 'option' + idx;
        variants.forEach(function (v) {
          var val = v[key];
          if (!val || imgFor[val]) return;
          if (v.featured_image && v.featured_image.src) imgFor[val] = v.featured_image.src;
        });
      }

      wrap.classList.add('smh-swatches');
      Array.prototype.forEach.call(wrap.querySelectorAll('.variant-input'), function (item) {
        if (item.classList.contains('smh-swatch')) return;
        var value = item.getAttribute('data-value');
        var label = item.querySelector('.variant__button-label');
        if (!label) return;
        item.classList.add('smh-swatch');
        var text = label.textContent.trim() || value || '';
        var src = imgFor[value];
        label.innerHTML = '';
        label.setAttribute('title', text);
        if (src) {
          var im = document.createElement('img');
          im.src = sizedSrc(src);
          im.alt = text;
          im.loading = 'lazy';
          label.appendChild(im);
        } else {
          label.style.background = fallbackColor(text);
        }
        var cap = document.createElement('span');
        cap.className = 'smh-swatch__name';
        cap.textContent = text;
        item.appendChild(cap);
      });
    });
  }

  /* ---------------------------------------------------------
     3. Warenkorb-Fortschritt (2 = 10 %, 3 = 15 %, 4 = 20 %)
     --------------------------------------------------------- */
  var TIERS = [{ q: 2, p: 10 }, { q: 3, p: 15 }, { q: 4, p: 20 }];

  function renderCartBar(count) {
    var bar = document.querySelector('[data-smh-cartbar]');
    if (!bar) return;
    var msg = bar.querySelector('[data-smh-cartbar-msg]');
    var fill = bar.querySelector('[data-smh-cartbar-fill]');
    var max = TIERS[TIERS.length - 1].q;
    var reached = null, next = null;
    TIERS.forEach(function (t) { if (count >= t.q) reached = t; });
    for (var i = 0; i < TIERS.length; i++) { if (count < TIERS[i].q) { next = TIERS[i]; break; } }

    if (fill) fill.style.width = Math.min(100, (count / max) * 100) + '%';

    if (msg) {
      if (!count) {
        msg.innerHTML = 'Ab <b>2 Artikeln</b> sparen Sie 10' + NBSP + '%.';
      } else if (next) {
        var need = next.q - count;
        msg.innerHTML = 'Nur noch <b>' + need + ' Artikel</b> bis <b>' + next.p + NBSP + '% Rabatt</b>' +
          (reached ? ' – aktuell ' + reached.p + NBSP + '% gesichert.' : '.');
      } else {
        msg.innerHTML = '<b>Maximaler Rabatt erreicht: 20' + NBSP + '%</b> auf Ihre Bestellung.';
      }
    }
    Array.prototype.forEach.call(bar.querySelectorAll('[data-smh-tier]'), function (el) {
      el.classList.toggle('is-on', count >= parseInt(el.getAttribute('data-smh-tier'), 10));
    });
  }

  function cartUrl() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) return window.Shopify.routes.root + 'cart.js';
    return '/cart.js';
  }

  function refreshCart() {
    fetch(cartUrl(), { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) { renderCartBar(c.item_count || 0); })
      .catch(function () {});
  }
  SMH.refreshCart = refreshCart;

  /* ---------------------------------------------------------
     4. Größenassistent
     --------------------------------------------------------- */
  var LABELS = ['XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL'];
  var DE_W = { XS: '34', S: '36', M: '38 / 40', L: '42', XL: '44', XXL: '46', '3XL': '48' };
  var DE_M = { XS: '44', S: '46 / 48', M: '50', L: '52', XL: '54', XXL: '56', '3XL': '58' };
  var BUILD_LABEL = { schlank: 'schlank', normal: 'normal', kraeftig: 'kräftig' };

  function clamp(n, a, b) { return Math.max(a, Math.min(b, n)); }

  function recommendApparel(o) {
    var w = o.weight, h = o.height, idx;
    if (o.gender === 'herren') {
      if (w <= 62) idx = 0; else if (w <= 72) idx = 1; else if (w <= 82) idx = 2;
      else if (w <= 93) idx = 3; else if (w <= 105) idx = 4; else if (w <= 118) idx = 5; else idx = 6;
      if (h >= 190) idx += 0.5; else if (h <= 170) idx -= 0.5;
    } else {
      if (w <= 52) idx = 0; else if (w <= 58) idx = 1; else if (w <= 66) idx = 2;
      else if (w <= 75) idx = 3; else if (w <= 85) idx = 4; else if (w <= 96) idx = 5; else idx = 6;
      if (h >= 178) idx += 0.5; else if (h <= 160) idx -= 0.5;
    }
    if (o.build === 'schlank') idx -= 0.5;
    if (o.build === 'kraeftig') idx += 0.5;
    if (o.fit === 'eng') idx -= 0.5;
    if (o.fit === 'weit') idx += 0.5;
    if (o.category === 'jacke') idx += 0.5;
    if (o.category === 'kleid' && o.fit !== 'weit') idx += 0.25;
    return LABELS[clamp(Math.round(idx), 0, 6)];
  }

  function recommendShoe(o) {
    var s = o.shoe;
    if (o.width === 'breit') s += 1;
    return String(s);
  }

  function findSizeFieldset(scope) {
    var wraps = scope.querySelectorAll('.variant-input-wrap');
    for (var i = 0; i < wraps.length; i++) {
      var n = ((wraps[i].getAttribute('name') || '') + ' ' + (wraps[i].getAttribute('data-handle') || '')).toLowerCase();
      if (n.indexOf('gr') > -1 || n.indexOf('size') > -1) return wraps[i];
    }
    return null;
  }

  function norm(s) { return String(s).toLowerCase().split(' ').join(''); }

  function selectSize(scope, size) {
    var fs = findSizeFieldset(scope);
    if (!fs) return false;
    var inputs = fs.querySelectorAll('input[type=radio]');
    var target = null, want = norm(size);
    Array.prototype.forEach.call(inputs, function (inp) {
      if (target) return;
      if (norm(inp.value) === want) target = inp;
    });
    if (!target) {
      Array.prototype.forEach.call(inputs, function (inp) {
        if (target) return;
        var v = norm(inp.value);
        if (v.indexOf(want) > -1 || want.indexOf(v) > -1) target = inp;
      });
    }
    if (!target) return false;
    target.checked = true;
    target.dispatchEvent(new Event('change', { bubbles: true }));
    target.click();
    return true;
  }

  function initAssistant() {
    var modal = document.querySelector('[data-smh-sa]');
    if (!modal || modal.getAttribute('data-smh-ready') === '1') return;
    modal.setAttribute('data-smh-ready', '1');
    var scope = document.querySelector('.product-section') || document;
    var state = {
      gender: modal.getAttribute('data-gender') || 'damen',
      category: modal.getAttribute('data-category') || 'oberteil',
      build: 'normal', fit: 'normal', width: 'normal', step: 0
    };
    var isShoe = state.category === 'schuh' || state.category === 'stiefel';
    var steps = Array.prototype.slice.call(modal.querySelectorAll('.smh-sa__step'));
    var dots = Array.prototype.slice.call(modal.querySelectorAll('.smh-sa__dot'));
    var panel = modal.querySelector('.smh-sa__panel');

    function show(i) {
      state.step = i;
      steps.forEach(function (s, n) { s.classList.toggle('is-active', n === i); });
      dots.forEach(function (d, n) { d.classList.toggle('is-on', n <= i); });
      if (panel) panel.scrollTop = 0;
    }
    function open() { modal.classList.add('is-open'); modal.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; show(0); }
    function close() { modal.classList.remove('is-open'); modal.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-smh-sa-open]')) { e.preventDefault(); open(); }
      if (e.target.closest('[data-smh-sa-close]')) { e.preventDefault(); close(); }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

    modal.addEventListener('click', function (e) {
      var opt = e.target.closest('.smh-sa__opt');
      if (opt) {
        var group = opt.getAttribute('data-group');
        Array.prototype.forEach.call(modal.querySelectorAll('.smh-sa__opt[data-group=' + group + ']'), function (o) { o.classList.remove('is-sel'); });
        opt.classList.add('is-sel');
        state[group] = opt.getAttribute('data-value');
        return;
      }

      if (e.target.closest('[data-smh-sa-next]')) {
        e.preventDefault();
        var err = modal.querySelector('.smh-sa__err');
        if (state.step === 0) {
          if (isShoe) {
            var shoeEl = modal.querySelector('[data-sa-shoe]');
            var sh = shoeEl ? parseFloat(shoeEl.value) : NaN;
            if (!sh || sh < 33 || sh > 50) { if (err) err.classList.add('is-on'); return; }
            state.shoe = Math.round(sh);
          } else {
            var hEl = modal.querySelector('[data-sa-height]');
            var wEl = modal.querySelector('[data-sa-weight]');
            var hh = hEl ? parseFloat(hEl.value) : NaN;
            var ww = wEl ? parseFloat(wEl.value) : NaN;
            if (!hh || !ww || hh < 130 || hh > 215 || ww < 35 || ww > 200) { if (err) err.classList.add('is-on'); return; }
            state.height = hh; state.weight = ww;
          }
          if (err) err.classList.remove('is-on');
        }
        if (state.step >= steps.length - 2) { finish(); return; }
        show(state.step + 1);
        return;
      }

      if (e.target.closest('[data-smh-sa-back]')) { e.preventDefault(); show(Math.max(0, state.step - 1)); return; }
      if (e.target.closest('.smh-sa__scrim')) { close(); return; }

      var addBtn = e.target.closest('[data-smh-sa-add]');
      if (addBtn) {
        e.preventDefault();
        var ok = selectSize(scope, addBtn.getAttribute('data-size'));
        close();
        setTimeout(function () {
          var atc = scope.querySelector('[data-add-to-cart]');
          if (ok && atc && !atc.disabled) { atc.click(); }
          else {
            var fs = findSizeFieldset(scope);
            if (fs) fs.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        }, 280);
      }
    });

    function finish() {
      var size = isShoe ? recommendShoe(state) : recommendApparel(state);
      var sizeEl = modal.querySelector('[data-sa-size]');
      var why = modal.querySelector('[data-sa-why]');
      var alt = modal.querySelector('[data-sa-alt]');
      if (sizeEl) sizeEl.textContent = size;
      if (isShoe) {
        if (why) why.textContent = 'Auf Basis Ihrer gewohnten Größe und Fußbreite. Unsere Schuhe fallen normal aus – bei kräftigem oder breitem Fuß empfehlen wir eine Nummer größer.';
        if (alt) alt.textContent = 'Zwischen zwei Größen? Nehmen Sie die größere – besonders bei gefütterten Herbstmodellen.';
      } else {
        var de = state.gender === 'herren' ? DE_M[size] : DE_W[size];
        if (why) why.textContent = 'Berechnet aus ' + state.height + ' cm, ' + state.weight + ' kg, Statur „' + (BUILD_LABEL[state.build] || 'normal') + '“ und Ihrer Passform-Vorliebe.' + (de ? ' Entspricht Konfektionsgröße ' + de + '.' : '');
        if (alt) alt.textContent = 'Liegen Sie zwischen zwei Größen, empfehlen wir bei Strick und Mänteln die größere.';
      }
      var addBtn = modal.querySelector('[data-smh-sa-add]');
      if (addBtn) addBtn.setAttribute('data-size', size);
      show(steps.length - 1);
    }
  }

  /* ---------------------------------------------------------
     Init
     --------------------------------------------------------- */
  function enhanceProduct() {
    var scope = document.querySelector('.product-section');
    if (!scope) return;
    translateLabels(scope);
    buildSwatches(scope);
  }

  function boot() {
    enhanceProduct();
    initAssistant();
    if (document.querySelector('[data-smh-cartbar]')) refreshCart();

    var products = document.querySelector('#CartDrawer [data-products]');
    if (products && window.MutationObserver) {
      new MutationObserver(function () { refreshCart(); }).observe(products, { childList: true, subtree: true });
    }
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-add-to-cart], .js-drawer-open-cart, .js-qty__adjust, .cart__remove')) {
        setTimeout(refreshCart, 600);
      }
    });
    document.addEventListener('ajaxCart:updated', refreshCart);

    var meta = document.querySelector('[data-product-blocks]');
    if (meta && window.MutationObserver) {
      new MutationObserver(function () { enhanceProduct(); }).observe(meta, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', function () { enhanceProduct(); initAssistant(); });
})();